import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Construction } from "lucide-react";

export default function ComingSoon({ title, description, icon: Icon }) {
  return (
    <div className="max-w-3xl mx-auto mt-10" data-testid="coming-soon-page">
      <Card className="border-slate-200">
        <CardContent className="p-10 text-center">
          <div className="mx-auto w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mb-5">
            {Icon ? <Icon className="w-7 h-7 text-green-700" aria-hidden="true" /> : <Construction className="w-7 h-7 text-green-700" aria-hidden="true" />}
          </div>
          <Badge variant="outline" className="bg-sky-50 text-sky-800 border-sky-300 mb-4" data-testid="coming-soon-badge">
            COMING SOON
          </Badge>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900 mb-3">{title}</h1>
          <p className="text-sm md:text-base leading-relaxed text-slate-600 max-w-xl mx-auto">{description}</p>
        </CardContent>
      </Card>
    </div>
  );
}
